/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import type {Components} from '@mui/material/styles';

import type {Theme} from '../types';

export const MuiToggleButtonGroup = {
  styleOverrides: {
    root: {
      border: '1px solid var(--mui-palette-divider)',
      boxShadow: 'var(--mui-shadows-1)',
      gap: '4px',
      padding: '4px',
    },
    grouped: {border: 0, margin: 0},
    firstButton: {borderRadius: '8px'},
    middleButton: {borderRadius: '8px'},
    lastButton: {borderRadius: '8px'},
  },
} satisfies Components<Theme>['MuiToggleButtonGroup'];
